import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromUser from '@app/lib/b2b-stores/user';
import * as fromRoot from '@app/lib/b2b-stores';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { LoggerService } from '@app/lib/b2b-services/util/logger.service';

@Pipe({
    name: 'permissions',
    standalone: false
})
export class PermissionsPipe implements PipeTransform {
  constructor(private rootStore: Store<fromRoot.State>) {}

  transform(values: string[], ...args: unknown[]): Observable<boolean> {
    if (!values || values?.length === 0) {
      LoggerService.warn('Permissions not found and values is ', values);
      return of(true);
    }

    return this.rootStore.pipe(select(fromUser.getUserPermissions)).pipe(
      map((items: string[]) => {
        // LoggerService.log('Permission pipe items ', items);
        if (items?.length > 0) {
          return (
            items.filter((item: string) => values?.indexOf(item) > -1)?.length >
            0
          );
        } else {
          return false;
        }
      })
    );
  }
}
